import {observer} from "mobx-react";
import './default-drawer-layout.scss';
import Scrollable from "../../scrollable/scrollable";

interface IDefaultDrawerLayoutProps {
    drawerHeader?: React.ReactNode;
    /** body is scrollable */drawerBody?: React.ReactNode;
    drawerFooter?: React.ReactNode;
}

/**
 * @type {React.FC<IDefaultDrawerLayoutProps>}
 * @param drawerBody - is this working
 */
const DefaultDrawerLayout : React.FC<IDefaultDrawerLayoutProps> = observer(({drawerHeader, drawerBody, drawerFooter})=> {
    return (
        <div className={'drawer-default-layout'}>
            <div className={'drawer-header'}>{drawerHeader}</div>
            <Scrollable>{drawerBody}</Scrollable>
            <div className={'drawer-footer'}>{drawerFooter}</div>
        </div>
    )
});

export default DefaultDrawerLayout;